module.exports = __webpack_public_path__ + "static/adelle_bold-webfont-woff-b4fc4254d19ed0116bb460f029889127.woff";